// extracted by mini-css-extract-plugin
export var originalPrice = "Price-module--originalPrice--f4877";